import api from '@/api';
import * as dateutil from '@/util/date-helper';

const convertFolderToClient = function (item: any): calendar.Folder {
    let folder: calendar.Folder = {
        ...item,
        id: item.id,
        parentFolderId: item.parentID,
        colorCode: item.color || 'none',
        displayName: item.displayName,
        events: item.calendarEventList,
        dbType: item.type,
        deptCode: item.deptCode,
    } as calendar.Folder;
    return folder;
}

const convertFolderToServer = function (item: calendar.Folder) {
    let folder: any = {
        ...item,
        ID: item.id,
        DisplayName: item.displayName,
        CalendarEventList: item.events,
        Type: item.dbType,
        Color: item.colorCode || 'none',
        ComCode: item.comCode,
        DeptCode: item.deptCode,
        PersonCode: item.personCode,
    };
    return folder;
}

const convertAppointmentTypeToClient = function(value: number) {
	switch (value) {
		case 1: return 'Single';
		case 2: return 'RecurringMaster';
		case 3: return 'Occurrence';
		case 4: return 'Exception';
	}
	return 'Single';
}

const convertAppointmentTypeToServer = function(value: string) {
	switch (value) {
		case 'Single': return 1;
		case 'RecurringMaster': return 2;
		case 'Occurrence' : return 3;
		case 'Exception': return 4;
	}
	return 1;
}

const convertEventToClient = function(item: any):calendar.CalendarItem {
    let event: calendar.CalendarItem = {
        ...item,
		id: item.id || item.ID,
        db_ewsid: item.ewsid || item.EwsID || item.ewsID,
		appointmentType: convertAppointmentTypeToClient(item.appointmentType || item.AppointmentType),
		subject: item.subject || item.Subject,
		location: item.location || item.Location,
		parentId: item.parentFolderID || item.ParentFolderID,
		parentFolderId: item.parentFolderID || item.ParentFolderID,
		start: ((item.startDate || item.StartDate) + '').replace('T', ' '),
		end: ((item.endDate || item.EndDate) + '').replace('T', ' '),
		organizer: {
			name: item.organizerName || item.OrganizerName,
			address: item.organizerAddress || item.OrganizerAddress,
		},
		importance: item.importance || item.Importance,
		isAllDayEvent : (item.isAllDayEvent || item.IsAllDayEvent) ? 'True' : 'False',
        isCancelled : item.isCancelled || item.IsCancelled,
        pidLidRecurrencePattern: item.recurringString || item.RecurringString,
		body: item.calendarEventBody?.body || item.CalendarEventBody?.body,		
		requiredAttendeesList: item.requiredAttendees && item.requiredAttendees.length ? item.requiredAttendees.map((x:any) => { return {name: x.Name, address: x.Address} }) : [],
        optionalAttendeesList: item.optionalAttendees && item.optionalAttendees.length ? item.requiredAttendees.map((x:any) => { return {name: x.Name, address: x.Address} }) : [],
        attachments: item.attachments || item.Attachments,
        code: item.attachmentFileCode || item.AttachmentFileCode,
        resourceId: item.resourceID || item.ResourceID,
        db_masterID: item.masterID || item.MasterID,
        db_selectID: item.selectGuid || item.SelectGuid,
	} as calendar.CalendarItem;
    return event;
}

const convertEventToServer = function(item: calendar.CalendarItem) {	
    let event: any = {
		ID: item.id || 0,
		AppointmentType: convertAppointmentTypeToServer(item.appointmentType),
        Subject: item.subject,
		Location: item.location,
		ParentFolderID: item.parentId || (item as any).ParentFolderId,
		StartDate: dateutil.uGetDateFormat('yyyy-MM-DD', dateutil.IEDate(item.start)) + 'T' + item.starttime,
		EndDate: dateutil.uGetDateFormat('yyyy-MM-DD', dateutil.IEDate(item.end)) + 'T' + item.endtime,
		IsAllDayEvent: item.isAllDayEvent,
        IsCancelled: item.isCancelled,
        RecurringString: item.pidLidRecurrencePattern,
		OrganizerName: item.organizer?.name,
		OrganizerAddress: item.organizer?.address,
		Importance: item.importance,
		CalendarEventBody: {
			Body: item.body,
		},
		RequiredAttendeesList: item.requiredAttendees && item.requiredAttendees.length ? item.requiredAttendees.map((x) => { return {Name: x.name, Address: x.address} }) : [],
        OptionalAttendeesList: item.optionalAttendees && item.optionalAttendees.length ? item.requiredAttendees.map((x) => { return {Name: x.name, Address: x.address} }) : [],
        Attachments: item.attachments,
        AttachmentFileCode: item.code,
        ResourceID: item.resourceId,
	};
    return event;
}

export default {

    /**
     * 현재 사용자 정보를 가져옵니다.
     */
    getCurrentUser(): Promise<account.User> {
        return api.get<account.User>({ url: '/api/account/user/current' });
    },

    getDeptFolderList(item: any) {
        item = convertFolderToServer(item);
        return api.post<Array<any>>({
            url: '/api/calendar/Calendar/getdeptfolderlist?funcName=getDeptFolderList',
            data: {
                PersonCode: item.PersonCode,
            }
        }).then((res) => {
            return res.map((data, idx) => {
                let result = {
                    ...convertFolderToClient(data),
                    selected: false,
                    index: idx,
                    checked: false,
                    isEWS: false,
                };
                return result;
            });
        });
    },

    getCompanyFolderList(item: any) {
        item = convertFolderToServer(item);
        return api.post<Array<any>>({
            url: '/api/calendar/Calendar/getcompanyfolderlist?funcName=getCompanyFolderList',
            data: {
                PersonCode: item.PersonCode,
                ComCode: item.ComCode,
            }
        }).then((res) => {
            return res.map((data, idx) => {
                let result = {
                    ...convertFolderToClient(data),
                    selected: false,
                    index: idx,
                    checked: false,
                    isEWS: false,
                };
                return result;
            });
        });
    },

    setFolderAttrs(item: any) {
        item = convertFolderToServer(item);
        return api.post<any>({
            url: '/api/calendar/Calendar/setattr?funcName=setFolderAttrs',
            data: {
                ID: item.ID,
                PersonCode: item.PersonCode,
                Color: item.Color,
            }
        });
    },

    getCalendarEventList(item: any) {
        return api.post<Array<any>>({
            url: '/api/calendar/Calendar/getevents?funcName=getCalendarEventList',
            data: {
                FolderID: item.FolderID,
                StartDate: dateutil.uGetDateFormat('yyyy-MM-DDT00:00:00', item.StartDate),
                EndDate: dateutil.uGetDateFormat('yyyy-MM-DDT00:00:00', item.EndDate),
            }
        }).then((res) => {
            return res.map((data) => {
                let newItem = convertEventToClient(data);
                let result = {
                    ...newItem,
                };
                return result;
            });
        });;
    },

    getCalendarDailyEventList(item: any) {
        return api.post<Array<any>>({
            url: '/api/calendar/Calendar/getdailyevents?funcName=getCalendarDailyEventList',
            data: {
                FolderID: item.FolderID,
                StartDate: dateutil.uGetDateFormat('yyyy-MM-DDT00:00:00', item.StartDate),
                EndDate: dateutil.uGetDateFormat('yyyy-MM-DDT00:00:00', item.EndDate),
            }
        }).then((res) => {
            return res.map((data) => {
                let newItem = convertEventToClient(data);
                let result = {
                    ...newItem,
                };
                return result;
            });
        });;
    },

    getCompanyDailyEventList(item: any) {
        return api.post<Array<any>>({
            url: '/api/hshi/calendar/getCompanyDailyEvents',
            data: {
                FolderID: item.FolderID,
                StartDate: dateutil.uGetDateFormat('yyyy-MM-DDT00:00:00', item.StartDate),
                EndDate: dateutil.uGetDateFormat('yyyy-MM-DDT00:00:00', item.EndDate),
            }
        }).then((res) => {
            return res.map((data) => {
                let newItem = convertEventToClient(data);
                let result = {
                    ...newItem,
                };
                return result;
            });
        });;
    },

    searchCalendarEventList(item: any) {
        return api.post<Array<any>>({
            url: '/api/calendar/Calendar/searchevents?funcName=searchCalendarEventList',
            data: {
                EwsFolderIDArray: item.EwsFolderIDArray || null,
                FolderID: item.ParentFolderID || null, 
                StartDate: item.StartDate || null, 
                EndDate: item.EndDate || null,
                Keyword: item.Keyword || null, 
                Subject: item.Subject || null,
                Location: item.Location || null, 
                OrganizerAddress: item.OrganizerAddress || null, 
                PersonCode: item.PersonCode, 
                RequiredAttendees: null, 
                OptionalAttendees: null, 
                EumNoCondition: false, 
                EumPageNumber: item.EumPageNumber || 1, 
                EumRowsPerPage: item.EumRowsPerPage || 9999, 
            }
        }).then((res) => {
            return res.map((data) => {
                let newItem = convertEventToClient(data);
                let result = {
                    ...newItem,
                    isEWS: false,
                };
                return result;
            });
        });;
    },

    /**
     * 반복일정 마스터 아이디를 가져옵니다
     * @param id 
     */
    getRecurringMasterID(id: string) {
        return api.post<string>({
            url: '/api/calendar/Calendar/getmasterid?funcName=getRecurringMasterID',
            data: {
                id: id,
            }
        });
    },
    
    // getCompanyEventList(item: any) {
    //     return api.post<Array<any>>({
    //         url: '/api/hshi/calendar/getCompanyEvents',
    //         data: {
    //             FolderID: item.FolderID,
    //             StartDate: dateutil.uGetDateFormat('yyyy-MM-DDT00:00:00', item.StartDate),
    //             EndDate: dateutil.uGetDateFormat('yyyy-MM-DDT00:00:00', item.EndDate),
    //         }
    //     }).then((res) => {
    //         return res.map((data) => {
    //             let newItem = convertEventToClient(data);
    //             let result = {
    //                 ...newItem,
    //             };
    //             return result;
    //         });
    //     });;
    // }
}
